import { createAction } from '@ngrx/store';

export const enum SystemActionsTypes {
  LoadServerTime = '[System] Load Server Time',
  SetServerTime = '[System] Set Server Time',
  LoadServerTimeFailure = '[System] Load Server Time Failure'
}

export const loadServerTime = createAction(SystemActionsTypes.LoadServerTime);
export const setServerTime = createAction(SystemActionsTypes.SetServerTime, ({ serverTime }: { serverTime: Date }) => ({
  payload: { serverTime }
}));
export const loadServerTimeFailure = createAction(SystemActionsTypes.LoadServerTimeFailure, ({ error }: { error: any }) => ({
  payload: { error }
}));
